var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBatteryCharging20 = function SvgBatteryCharging20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.538 21.74v-2.817h-2.02l2.943-4.663v2.817h2.019zm-8.193-.24a.87.87 0 0 1-.644-.26.87.87 0 0 1-.26-.644V5.144q0-.383.26-.644a.87.87 0 0 1 .644-.26h1.808V2.5h3.692v1.74h1.81q.384 0 .643.26a.88.88 0 0 1 .259.644v6.952a6 6 0 0 0-.77.088q-.37.068-.73.195V5.73H8.94v12.24h2.097q0 .996.313 1.896t.894 1.633z"
  })));
};
export default SvgBatteryCharging20;